module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC4SURBVHgB3ZLhDYJADIWrC8gIN4oj6AZsIBvIBrDBuYk4gSMQJ5AN6qv2SEXMCfKD8CUvkLv2SxsgWhQrZt7hWdA4GmQvkiteEqSi4cgAF+IXtU70M6hPtfccJAGPuEjzVhpNTyupkNxcHHuaE6TQ+zuS6QatxGuhQ05mxVTPD9oolCLU809JZ9/ayJ5jyyqduu8SU5TbiXru45IYQbKmCRBJQ//C7998DF5+ewdXhmxoODekpNnwABdXRRfYMOWbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/icon-email.png
// module id = LdxN
// module chunks = 0